document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-card-form').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const button = form.querySelector('button[type="submit"]');
      const formData = new FormData(form);
      const variantId = formData.get('id');

      if (!variantId) {
        alert('Please select a variant.');
        return;
      }

      button.disabled = true;
      button.textContent = 'Adding...';

      try {
        // Add to cart request
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        });

        const data = await response.json();

        if (!response.ok) throw new Error(data.description || 'Add to cart failed.');

        // ✅ Fetch the updated cart drawer HTML
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          const cartResponse = await fetch('/cart?section_id=cart-drawer');
          const cartHtml = await cartResponse.text();

          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = cartHtml;

          const newDrawer = tempDiv.querySelector('cart-drawer');
          if (newDrawer) {
            // Replace drawer contents
            cartDrawer.innerHTML = newDrawer.innerHTML;

            // ✅ Remove "is-empty" class if cart has items
            if (cartDrawer.querySelectorAll('.cart-item').length > 0) {
              cartDrawer.classList.remove('is-empty');
            } else {
              cartDrawer.classList.add('is-empty');
            }

            // ✅ Open drawer
            cartDrawer.classList.add('is-open');
          }
        } else {
          // Fallback (no drawer found)
          window.location.href = '/cart';
        }

        // ✅ Button feedback
        button.textContent = 'Added!';
        setTimeout(() => {
          button.textContent = 'Add to cart';
          button.disabled = false;
        }, 1500);

      } catch (err) {
        console.error('Add to cart error:', err);
        alert(err.message || 'Something went wrong.');
        button.disabled = false;
        button.textContent = 'Add to cart';
      }
    });
  });
});
